module.exports = __webpack_public_path__ + "static/media/search.5de43616.svg";